import React from "react";

/**
 * ReferralMilestoneCard — "A referrer just earned from a successful placement"
 *
 * Anonymized referrer with tier badge inline. No CTAs.
 *
 * Props:
 *   card — feed card object with metadata containing:
 *     referrer_display_name, referrer_tier, role_title, company_name
 */
const ReferralMilestoneCard = ({ card }) => {
  const meta = card.metadata || {};
  const tier = meta.referrer_tier || "bronze";

  const tierStyles = {
    bronze:   { bg: "#f5e6d3", color: "#8b4513", label: "BRONZE" },
    silver:   { bg: "#e8e8e8", color: "#555",    label: "SILVER" },
    gold:     { bg: "#fef3c7", color: "#a16207", label: "GOLD" },
    platinum: { bg: "#e0f2fe", color: "#0369a1", label: "PLATINUM" },
  };

  const ts = tierStyles[tier] || tierStyles.bronze;

  return (
    <div style={styles.card}>
      <div style={styles.row}>
        <div style={styles.iconWrap}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3a6ed4" strokeWidth="2">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        </div>

        <div style={styles.content}>
          <p style={styles.message}>
            A referrer just earned from a successful placement this week
          </p>
          <div style={styles.metaRow}>
            <span style={{ ...styles.tierBadge, backgroundColor: ts.bg, color: ts.color }}>
              {ts.label}
            </span>
            <span style={styles.timestamp}>{formatTime(card.created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

function formatTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const diffHrs = (now - date) / (1000 * 60 * 60);
  if (diffHrs < 1) return "Just now";
  if (diffHrs < 24) return `${Math.floor(diffHrs)}h ago`;
  const diffDays = Math.floor(diffHrs / 24);
  if (diffDays === 1) return "1d ago";
  return `${diffDays}d ago`;
}

const styles = {
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    marginBottom: "16px",
    padding: "18px 20px",
  },
  row: {
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
  },
  iconWrap: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    backgroundColor: "#ebf6fd",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  message: {
    fontSize: "15px",
    color: "#0f172a",
    margin: "0 0 8px 0",
    lineHeight: 1.4,
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  tierBadge: {
    fontSize: "11px",
    fontWeight: "700",
    padding: "3px 10px",
    borderRadius: "5px",
    letterSpacing: "0.3px",
  },
  timestamp: {
    fontSize: "12px",
    color: "#94a3b8",
  },
};

export default ReferralMilestoneCard;
